export const MAGIC_LINK_TIMEOUT = 60 * 60 * 1000; // 60 minutes
